export default __webpack_public_path__ + "static/media/elan-solar-bg.bc8f0d14.jpg";